/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * PersonalAreaIcon - Auto-generated from icon.js
 */
export const PersonalAreaIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M8 5.5L5.5 5.5M8 8.5L5.5 8.5M14.5 5.5H12M14.5 8.5L12 8.5M8 11.5H5.5M8 14.5H5.5M14.5 11.5H12M14.5 14.5H12M2 5L2 15C2 16.6569 3.34315 18 5 18C6.65685 18 13.3431 18 15 18C16.6569 18 18 16.6569 18 15V5C18 3.34315 16.6569 2 15 2L5 2C3.34315 2 2 3.34315 2 5Z" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default PersonalAreaIcon;
